import React from 'react';
import {withTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import './cashPayment.scss';

const WaiterPayment = ({t, branchInfo}) => {
  const history = useHistory();

  return (
    <div className={ 'payment-block waiter-payment' }>
      {/*<h2>{ t('payment.payment_type.cash') }</h2>*/}
      <div className={ 'payment-content' }>
        <div className={ 'change-phone-number-block' }>
          {t('payment.waiter.description')}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(WaiterPayment);
